<section class="border-border" [class.show-border]="showBorders">
  <div
    *ngFor="let item of items; let i = index"
    class="item"
    [ngClass]="tabIndex === i ? 'active border-accent' : 'no-border'"
    (click)="tabIndex = i; tabChange.emit(tabIndex)"
  >
    <p class="user-select-none">{{ item.title }}</p>
    <div
      class="badge-circle background-info user-select-none"
      *ngIf="item.count !== undefined"
      [style.background]="item.countColor + '!important'"
    >
      <p class="user-select-none">{{ item.count }}</p>
    </div>
  </div>
</section>
